export default {
  generalTransactions: [],
  generalTransaction: {}
}
